import * as React from "react";
import styled from "styled-components";
import { useState, useCallback } from "react";
import usePluginEntities from "hooks/usePluginEntities";
import SearchFilterBanner from "views/components/searchbar/SearchFilterBanner";
import Store from "logic/local-storage/Store";
import { SEARCH_BAR_GAP } from "views/components/searchbar/SearchBarLayout";
export const PLUGGABLE_CONTROLS_HIDDEN_KEY = "pluggableSearchBarControlsAreHidden";
const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: ${SEARCH_BAR_GAP};
`;
const usePluggableControls = () => {
  var _a;
  const searchBarControls = (_a = usePluginEntities("views.components.searchBar")) != null ? _a : [];
  const existingControls = searchBarControls.map((controlFn) => controlFn()).filter((control) => !!control);
  const leftControls = existingControls.filter(({ placement }) => placement === "left");
  const rightControls = existingControls.filter(({ placement }) => placement === "right");
  return {
    leftControls,
    rightControls
  };
};
const renderControls = (controls) => controls == null ? void 0 : controls.map(({ component: ControlComponent, id }) => /* @__PURE__ */ React.createElement(ControlComponent, { key: id }));
const componentHasContent = ({
  hidePluggableControlsPreview,
  showLeftControls,
  showRightControls,
  hasPluggableControls,
  hasLeftColFallback = void 0,
  hasRightColFallback = void 0
}) => {
  if (hasPluggableControls) {
    return true;
  }
  if (hidePluggableControlsPreview) {
    return false;
  }
  const shouldShowLeftCol = showLeftControls && hasLeftColFallback;
  const shouldShowRightCol = showRightControls && !!hasRightColFallback;
  return shouldShowLeftCol || shouldShowRightCol;
};
const PluggableSearchBarControls = ({ showLeftControls = true, showRightControls = true }) => {
  const [hidePluggableControlsPreview, setHidePluggableControlsPreview] = useState(
    () => !!Store.get(PLUGGABLE_CONTROLS_HIDDEN_KEY)
  );
  const { leftControls, rightControls } = usePluggableControls();
  const hasPluggableControls = !!((leftControls == null ? void 0 : leftControls.length) || (rightControls == null ? void 0 : rightControls.length));
  const onHidePluggableControlsPreview = useCallback(() => {
    setHidePluggableControlsPreview(true);
    Store.set(PLUGGABLE_CONTROLS_HIDDEN_KEY, true);
  }, []);
  const leftColFallback = /* @__PURE__ */ React.createElement(SearchFilterBanner, { onHide: onHidePluggableControlsPreview, pluggableControls: leftControls });
  const shouldRenderContainer = componentHasContent({
    hidePluggableControlsPreview,
    showLeftControls,
    showRightControls,
    hasPluggableControls,
    hasLeftColFallback: !!leftColFallback
  });
  if (!shouldRenderContainer) return null;
  return /* @__PURE__ */ React.createElement(Container, null, /* @__PURE__ */ React.createElement("div", null, showLeftControls && /* @__PURE__ */ React.createElement(React.Fragment, null, renderControls(leftControls), leftColFallback)), /* @__PURE__ */ React.createElement("div", null, showRightControls && renderControls(rightControls)));
};
export default PluggableSearchBarControls;
